import axios from '../axios/axios';
import {
  ANNUITY_DATA_REQUEST,
  ANNUITY_DATA_SUCCESS,
  ANNUITY_DATA_FAIL,
} from '../constants/existingAnnuityConstants';

export const exitingAnnuityAction = () => async (dispatch) => {
  try {
    dispatch({ type: ANNUITY_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s27',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: ANNUITY_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: ANNUITY_DATA_FAIL,
      payload: error,
    });
  }
};
